module.exports = __webpack_public_path__ + "img/StarCheckmark.80680357.svg";